import React from 'react';
import { Tabs } from 'antd';
import cn from 'classnames';
import './styles.scss';

const MyTabs = ({ className, children, ...rest }) => {
  return (
    <Tabs className={cn('my-tabs', className)} {...rest}>
      {children}
    </Tabs>
  );
};

export default MyTabs;
